// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2pSib","question":"styles_question__28Q8W","description":"styles_description__1x71f"};